import {
  APP_MANAGED_ROUTES,
  FooterLinkProps,
  useGetAppInitDetails,
  useIsAuthenticated,
  highmarkCommon,
} from '@highmark-web/highmark-common';
import { useIntl } from '@leagueplatform/locales';

export const useFooterLinks = () => {
  const { formatMessage } = useIntl();
  const { isAuthenticated } = useIsAuthenticated();
  const { eligibilityInfo } = useGetAppInitDetails({
    enabled: !!isAuthenticated,
  });

  const legalUrl = APP_MANAGED_ROUTES.LEGAL;

  const { feedbackSurveyUrl } = highmarkCommon.getConfig();

  const isPostAuth = isAuthenticated && eligibilityInfo?.eligible;

  // only show authentication-required links if the user is logged in and eligible to access the app
  const footerLinks: FooterLinkProps[] = isPostAuth
    ? [
        {
          text: formatMessage({ id: 'LEGAL' }),
          url: legalUrl,
          linkProps: {
            target: '_self',
          },
        },
        {
          text: formatMessage({ id: 'ALL_LANGUAGES' }),
          url: '/all-languages.pdf',
        },
        {
          text: formatMessage({ id: 'GIVE_FEEDBACK' }),
          url: feedbackSurveyUrl,
          linkProps: {
            target: '_blank',
          },
        },
      ]
    : [
        {
          text: formatMessage({ id: 'NON_DISCRIMINATION_POLICY' }),
          url: '/nondiscrimination-policy-statement.pdf',
        },
      ];

  return { footerLinks };
};
